import { Box } from "@mui/material"
import { styled } from "@mui/system"
import { VideoPlatform } from "app-constants/constants"
import VideoPlatformText from "components/common/VideoPlatformText"
import moment, { Moment } from "moment-timezone"
import pluralize from "pluralize"
import React from "react"
import { pxToRem } from "utils/helpers"

interface DetailsRowText {
  startAt: Moment
  endAt: Moment
  platform: VideoPlatform
  className?: string
}

const DetailsRowText = (props: DetailsRowText) => {
  const { startAt, endAt, platform, className } = props
  const durationMinutes = moment(endAt).diff(startAt, "minutes")
  const startDate = moment(startAt).format("MMM D, YYYY")
  const startTime = moment(startAt).format("hh:mm a z")
  const durationText = `${durationMinutes} ${pluralize("min", durationMinutes)}`

  return (
    <_Container className={className}>
      <p>{startDate}</p>
      <_Divider />
      <p>{startTime}</p>
      <_Divider />
      <p>{durationText}</p>
      <_Divider />
      <VideoPlatformText platform={platform} />
    </_Container>
  )
}

export default DetailsRowText

const _Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexFlow: "row wrap",
  alignItems: "center",
  gap: pxToRem(20),
  width: "100%",
  ...theme.fonts.lato400,
  fontSize: pxToRem(16),
  lineHeight: pxToRem(22),
  "& > p": {
    margin: 0,
  },
  "& > span": {
    fontSize: "8px",
  },
})) as typeof Box

const _Divider = () => <span aria-hidden="true">&#9679;</span>
